import * as ActionTypes from './types.action';

export const getOrderFeedback = accountId => ({
  type: ActionTypes.GET_ORDER_FEEDBACK_REQUESTED,
  accountId,
});

// reviews: [{itemId, rating, comment}]
export const submitOrderFeedback = reviews => ({
  type: ActionTypes.SUBMIT_ORDER_FEEDBACK_REQUESTED,
  reviews,
});

export const snoozeOrderFeedback = () => ({
  type: ActionTypes.SNOOZE_ORDER_FEEDBACK,
});

export const dismissOrderFeedback = () => ({
  type: ActionTypes.DISMISS_ORDER_FEEDBACK,
});
